import { createAction, props } from "@ngrx/store";
import { StadiumWithSectorsAndSeats } from "../interfaces/State/Stadium/stadium-with-sectors-and-seats";

export const setStadiumSeats = createAction('SetStadiumSeats', props<{stadium: StadiumWithSectorsAndSeats}>())